<template>
	<PageWrapper>
		<Page @user-authenticated="getUserData">
			<template #default>
				<div class="below-header"></div>
				<div class="app-content">
					<SubmaranSideMenu></SubmaranSideMenu>
					<div class="routed-content">
						<AuthorizationGuard>
							<router-view />
						</AuthorizationGuard>

						<!--Iam User Settings Popup to remind user -->
						<UpdateAwsUsernameReminder />
					</div>
				</div>
			</template>
			<template #menu>
				<HeaderButton @click="$router.push('/')">SUBMARAN</HeaderButton>
			</template>
			<template #sidemenu>
				<ButtonDropdown icon="ic_user" :title="userData?.email">
					<Feature name="access_keys">
						<DropdownMenuItem title="Access Keys" @click="goToRoute('/access-keys')" />
					</Feature>
					<Feature name="user_settings">
						<DropdownMenuItem title="Settings" @click="goToRoute('/settings')" />
					</Feature>
					<DropdownMenuItem title="Logout" @click="logout()" />
				</ButtonDropdown>
			</template>
		</Page>
	</PageWrapper>
</template>

<script>
import SubmaranSideMenu from './components/SubmaranSideMenu.vue'
import { Page, api, HeaderButton, ButtonDropdown, DropdownMenuItem, authFlow, PageWrapper, Feature, dmStore } from 'dmui_components'
import UpdateAwsUsernameReminder from './components/UpdateAwsUsernameReminder.vue'
import AuthorizationGuard from './components/AuthorizationGuard.vue'
import { useRouter } from 'vue-router'
import { provide, ref, computed } from 'vue'
import { getOnce } from '@/utility/getOnce'

export default {
	name: 'App',
	components: {
		SubmaranSideMenu,
		Page,
		HeaderButton,
		ButtonDropdown,
		DropdownMenuItem,
		PageWrapper,
		UpdateAwsUsernameReminder,
		Feature,
		AuthorizationGuard
	},
	setup() {
		const router = useRouter()

		const userData = ref()

		const getUserData = async () => {
			userData.value = dmStore.getUserData()
		}

		provide(
			'userData',
			computed(() => userData.value)
		)
		provide(
			'getRegionsTree',
			getOnce(async () => await api('/regions_tree'))
		)
		provide(
			'getIndustriesTree',
			getOnce(async () => await api('/industries_tree'))
		)
		return {
			goToRoute: (route) => router.push(route),
			userData,
			getUserData
		}
	},
	methods: {
		logout() {
			authFlow.logout()
		}
	}
}
</script>

<style lang="less">
// DO NOT DELETE - THESE ARE GLOBAL STYLES THAT ARE AVAILABLE THROUGHOUT THE APP
@import '/node_modules/dmui_components/src/general.less';
@import '/node_modules/dmui_components/src/text.less';
@import '/node_modules/@vuepic/vue-datepicker/dist/main.css';

html {
	font-size: 14px;
}

.app-content {
	display: flex;
	flex-flow: row;
}

.below-header {
	height: 42px;
}

/** Routed-content is the container of different pages that excludes the menu */
.routed-content {
	display: flex;
	flex: 1;
	flex-direction: column;
	padding: 20px;
	width: 960px;
	margin-left: 275px;
	& > div > .form-content {
		max-width: 1020px;
	}
}
</style>
